module.exports = __webpack_public_path__ + "src/assets/games/9/216.jpg";